function createAnalyticsData({
  element,
  product = {},
  meta = {},
  detail,
}) {
  const {
    businessCodes: {
      sourcecode,
    } = {},
    analytics: {
      applyflowID,
      pmc,
    } = {},
    flags: {
      isCobrand,
    } = {},
    description,
  } = product;
  const metaData = {
    journey: 'cardApplication',
    applicationType: 'supp',
    experience: 'MobileWeb',
    flowType: 'cardmember',
    applicationId: '',
    ...meta,
  };
  if (applyflowID && sourcecode) {
    metaData.applyflowID = applyflowID;
    metaData.sourcecode = `de-${'consumer'}-${sourcecode}`;
    metaData.eep = sourcecode;
    metaData.journeyChannelType = isCobrand ? 'partner-consumer' : 'online-consumer';
    metaData.products = [{
      id: pmc,
      type: 'supp',
      lineOfBusiness: 'consumer',
      paymentType: 'charge',
      currencyCode: 'EUR',
      locale: 'de-DE',
      description,
    }];
  }
  const event = {
    type: 'journey',
    element,
    identifier: 'axp-apply-supplementary-card-germany',
    timestamp: new Date().toISOString(),
    meta: metaData,
  };
  if (detail) {
    event.detail = detail;
  }
  return {
    event,
  };
}
export default createAnalyticsData;
